import { Fragment } from "react";

import classes from "./DrinkRecipe.module.css";

// component displays recipe for cocktail
const DrinkRecipe = (props) => {
  // recipe is stored as array or strings, list these strings out in order
  const recipe = props.recipe.map((stage, i) => {
    return (
      <div key={stage} className={classes.recipe_instruction}>
        {i + 1}. {stage}
      </div>
    );
  });

  return (
    <Fragment>
      <div className={classes.title}>Instructions</div>
      <div className={classes.drink_recipe}>{recipe}</div>
    </Fragment>
  );
};

export default DrinkRecipe;
